<div class="card p-0 border-0">
  <img [ngStyle]="{'height': isDetail ? '300px' : '160px'}" class="card-img"
    src="{{images[currentSlide] | imgResize: isDetail ? 'large' : 'medium' :'fff':50}}" alt="Card image">
  <div class="card-img-overlay  p-0" style="height: 85%;">
    <div class="d-flex h-100 align-items-center" *ngIf="images.length > 1">
      <div class="d-flex w-100 justify-content-between">
        <button class="btn" (click)="$event.stopPropagation(); nextSlide(-1)">
          <fa-icon [icon]="faChevronLeft"></fa-icon>
        </button>
        <button class="btn" (click)="$event.stopPropagation(); nextSlide(1)">
          <fa-icon [icon]="faChevronRight"></fa-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="card-footer bg-white" *ngIf="images.length > 1 && isDetail">
    <img (click)="slideTo(i)" *ngFor="let image of images; let i = index;" src="{{image}}" alt="" srcset="">
  </div>
</div>